<template>
  <div>
    <h4>{{ header }}</h4>
    <div v-if="!noMissingFiles" class="md-layout md-layout-item md-size-90">
      <!-- Select File Explorer -->
      <md-card md-with-hover>
        <md-card-header>
          <div class="md-layout-item md-zie-30">
            <md-avatar class="md-avatar-icon md-primary md-fileinput">
              <md-icon>
                attachment
                <input
                  type="file"
                  :accept="missingFileMimeTypes"
                  multiple
                  @change="onChargeFile"
                />
              </md-icon>
            </md-avatar>
          </div>
          <div class="md-layout-item md-zie-70">
            <h4>{{ buttonLabel }} {{ buttonLabelPostfix }}</h4>
          </div>
        </md-card-header>
      </md-card>
    </div>

    <div class="md-layout md-alignment-center-center">
      <div
        v-for="(file, type) in filesByType"
        :key="type"
        :class="`md-layout md-layout-item md-size-${columnSize}`"
      >
        <!-- CARD File Active -->
        <md-card md-with-hover class="md-layout md-layout-item md-size-100">
          <md-card-header class="md-layout md-size-100">
            <div class="md-layout-item md-zise-100">
              <h5>{{ file.name }}</h5>
            </div>
            <md-button
              v-if="deletable"
              class="md-success md-just-icon md-round"
              @click="deleteFile(type)"
            >
              <md-icon>delete</md-icon>
            </md-button>
          </md-card-header>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { makeFilesByType } from "./utils";

const filesToMimes = {
  pdf: "application/pdf",
  xml: "text/xml",
};

export default {
  name: "FileLoad",

  props: {
    header: {
      type: String,
      default: "Archivos XML y Pdf",
    },
    loadedFilesByType: {
      type: Object,
      default: () => ({}),
    },
    buttonLabelPostfix: {
      type: String,
    },
    deletable: {
      type: Boolean,
      default: true,
    },
    columnSize: {
      type: Number,
      default: 100,
    },
  },

  computed: {
    buttonLabel() {
      return this.missingFileTypes.join(" Y ");
    },
    pdfFile() {
      return this.filesByType.pdf;
    },
    xmlFile() {
      return this.filesByType.xml;
    },
    noMissingFiles() {
      return !this.missingFileTypes.length;
    },
    missingFileMimeTypes() {
      const missing = this.missingFileTypes;

      return missing.map((file) => filesToMimes[file]).join(",");
    },
    missingFileTypes() {
      let missing = [];

      Object.keys(filesToMimes).forEach((file) => {
        const localFile = this[`${file}File`];
        if (!localFile) {
          missing.push(file);
        }
      });

      return missing;
    },
  },

  methods: {
    deleteFile(type) {
      const filesByType = { ...this.filesByType };
      delete filesByType[type];
      this.filesByType = filesByType;
    },
    onChargeFile(e) {
      let files = e.target.files || e.dataTransfer.files;
      files = [...files];
      e.srcElement.value = null;
      this.isFailed = false;

      if (files.length > 2) {
        this.$emit(
          "failed",
          null,
          "Asegurese de adjuntar Archivos PDF y XML de Factura"
        );
        return;
      }

      const byType = makeFilesByType(files);

      this.filesByType = {
        ...this.filesByType,
        ...byType,
      };
    },
  },

  data() {
    return {
      filesByType: this.loadedFilesByType,
    };
  },

  watch: {
    filesByType: {
      immediate: true,
      handler(value) {
        this.$emit("filesByTypeLoaded", value);
      },
    },
    loadedFilesByType(value = {}) {
      this.filesByType = value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Inputs/XmlPdfLoader.vue